import * as React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";
import { useI18n } from "../i18n/I18nProvider";
import { SectionTitle } from "../i18n/SectionTitle";

/** Projets affichés sur l’accueil (ordre = ids dans works.js / API) */
const HOME_FEATURED_PROJECT_IDS = ["1", "2", "3", "4"];

const SERVICE_ITEMS = [
  {
    id: "wordpress",
    labelKey: "home.serviceWordpress",
    image: "/images/wordpress.png",
  },
  {
    id: "php",
    labelKey: "home.servicePhp",
    image: "/images/php.png",
  },
  {
    id: "node",
    labelKey: "home.serviceNode",
    image: "/images/node.svg",
  },
  {
    id: "express",
    labelKey: "home.serviceExpress",
    image: "/images/express.svg",
  },
  {
    id: "angular",
    labelKey: "home.serviceAngular",
    image: "/images/angular.png",
  },
  {
    id: "react",
    labelKey: "home.serviceReact",
    image: "/images/react.png",
  },
];

function Home() {
  const { t } = useI18n();
  const seeMore = t("home.seeMore");
  const [featuredProjects, setFeaturedProjects] = useState([]);
  const [featuredLoading, setFeaturedLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_URL}/api/works`)
      .then((res) => {
        if (cancelled) return;
        const byId = new Map(
          (Array.isArray(res.data) ? res.data : []).map((w) => [String(w.id), w])
        );
        const ordered = HOME_FEATURED_PROJECT_IDS.map((id) => byId.get(id)).filter(
          Boolean
        );
        setFeaturedProjects(ordered);
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setFeaturedProjects([]);
      })
      .finally(() => {
        if (!cancelled) setFeaturedLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="home-page">
      <section className="services_section layout_padding home-services">
        <div className="">
          <div className="home-services__head">
            <SectionTitle
              beforeKey="home.servicesTitle"
              afterKey="home.servicesAccent"
              className="services_taital"
            />
          </div>

          <div className="home-services__carousel">
            <ul className="home-services__track">
              {SERVICE_ITEMS.map((item) => (
                <li key={`main-${item.id}`} className="home-services__cell">
                  <article className="home-services__item">
                    <span className="home-services__icon" aria-hidden>
                      <img src={item.image} alt="" />
                    </span>
                    <h3 className="home-services__title">{t(item.labelKey)}</h3>
                  </article>
                </li>
              ))}
            </ul>
            <ul className="home-services__track" aria-hidden="true">
              {SERVICE_ITEMS.map((item) => (
                <li key={`clone-${item.id}`} className="home-services__cell">
                  <article className="home-services__item">
                    <span className="home-services__icon" aria-hidden>
                      <img src={item.image} alt="" />
                    </span>
                    <h3 className="home-services__title">{t(item.labelKey)}</h3>
                  </article>
                </li>
              ))}
            </ul>
          </div>

          <div className="home-services__actions">
            <Link
              to="/portfolio"
              className="pro-btn pro-btn--primary home-services__cta"
            >
              {t("home.myPortfolio") || "My Portfolio"}
            </Link>
          </div>
        </div>
      </section>

      <div className="portfolio_section layout_padding">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <SectionTitle
                beforeKey="home.latestTitle"
                afterKey="home.latestAccent"
                className="portfolio_taital"
              />
            </div>
          </div>
          <div className="portfolio_section">
            <div className="portfolio_section_2">
              {featuredLoading ? (
                <p className="blog_text">{t("portfolio.loading")}</p>
              ) : featuredProjects.length === 0 ? (
                <p className="blog_text">{t("home.latestEmpty")}</p>
              ) : (
                <div className="row">
                  {featuredProjects.map((project) => (
                    <div className="col-md-6" key={project.id}>
                      <div className="container_main">
                        {project.images && project.images.length > 0 ? (
                          <img
                            src={`${API_URL}${project.images[0]}`}
                            alt={project.name_site || ""}
                            className="image modnv"
                          />
                        ) : (
                          <div className="home-latest__placeholder" aria-hidden />
                        )}
                        <div className="overlay">
                          <div className="text">
                            <div className="btn_main">
                              <h3
                                className="banner_text"
                                style={{ fontWeight: "bolder" }}
                              >
                                {project.name_site}
                              </h3>
                              <div className="buy_bt">
                                <Link
                                  to={`/portfolioDetails/${project.id}`}
                                  className="see-more-link pro-btn pro-btn--primary"
                                >
                                  {seeMore}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="seemore_bt">
            <Link to="/portfolio" className="pro-btn pro-btn--primary">
              {t("home.allProjects")}
            </Link>
          </div>
        </div>
      </div>

      <div className="project_box home-hire-banner">
        <div className="container">
          <div className="project_main home-hire-banner__row">
            <h1 className="hire_text home-hire-banner__title">{t("home.hire")}</h1>
            <div className="callnow_bt home-hire-banner__action">
              <Link to="/contact" className="pro-btn pro-btn--primary">
                {t("home.callNow")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
